// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__20x_O","noInteraction":"EventWrapper_noInteraction__3UvXZ"};